import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building-consents',
  templateUrl: './building-consents.component.html',
  styleUrls: ['./building-consents.component.scss']
})
export class BuildingConsentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
